import { useSyncExternalStore } from 'react';

const subscribeToNothing = () => () => {};

/**
 * `false` while React hydrates this component, `true` from its next render on.
 * This pattern is basically the same as `useEffect(() => setHydrated(true), [])`
 * but slightly better because it was made specifically for cases where we need
 * to tell React we're dealing with an external variable that can change.
 */
export function useHydrated() {
  return useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false
  );
}
